import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import { DayPicker, addToRange } from 'react-day-picker';
import { pt, he, es, en, it, fr, ar } from "react-day-picker/locale";
import 'react-dates/initialize';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';

import CurrencyConverter from '../CurrencyConverter';
import SaveCalendar from './SaveCalendar';

import { isRTL } from '../../helpers/formatLocale';
import messages from '../../locale/jsonMessages';
import s from "react-day-picker/style.css";
import t from '../../styles/becomeHostCalendar.css'

const localeArray = {
  'en-US': en,
  'es': es,
  'it-IT': it,
  'fr-FR': fr,
  'pt-PT': pt,
  'ar': ar,
  'he': he
};


class DayDragCalendar extends Component {

  static propTypes = {
    change: PropTypes.func,
    formName: PropTypes.string,
    disabledDates: PropTypes.array,
    blockedDates: PropTypes.array,
  };

  static defaultProps = {
    disabledDates: [],
    blockedDates: [],
    listId: null,
    sources: []
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDays: [],
      from: undefined,
      to: undefined,
      dateRange: [],
      //availableDates: [],
      chooseRangeDate: [],
      isPrice: [],
      sources: []
    };
    this.isDaySelected = this.isDaySelected.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.resetCalendar = this.resetCalendar.bind(this);
    this.renderDay = this.renderDay.bind(this);
    this.resetDatePickerChange = this.resetDatePickerChange.bind(this);
  }

  componentDidMount() {
    this.setState({ month: moment() })
  }

  UNSAFE_componentWillMount() {
    const { blockedDates, sources, availableDatesPrices } = this.props;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }

    let sourcesValue = [];
    let sourceObject = {};

    availableDatesPrices && availableDatesPrices.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.date;
      sourcesValue.push(sourceObject);
    });
    this.setState({ sources: sourcesValue });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { blockedDates, sources, availableDatesPrices } = nextProps;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }
    let sourcesValue = [];
    let sourceObject = {};

    availableDatesPrices && availableDatesPrices.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.date;
      sourcesValue.push(sourceObject);
    });
    this.setState({ sources: sourcesValue });

  }

  renderDay = (props) => {
    const { currency } = this.props;
    const { sources } = this.state;
    let specialPrice = sources?.find((item, key) => moment(props['data-day']).format('YYYY-MM-DD') == moment(item.blockedDates).format('YYYY-MM-DD'));
    return (
      <td class={props.className} role={props?.role} data-day={props['data-day']}>
        {props.children}
        {specialPrice &&
          <div className='priceAlignment'>
            <CurrencyConverter
              amount={specialPrice.isSpecialPrice}
              from={currency}
            />
          </div>
        }
      </td>
    );
  }


  isDaySelected(day) {
    const { selectedDays } = this.state;

    if (selectedDays.length > 0) {
      return selectedDays.some(selectedDay =>
        moment(selectedDay).isSame(day)
      );
    }
  }

  async handleDayClick(day, { start, end, selected, disabled }) {
    const { blockedDates, change, formName } = this.props;
    let selectedDays = blockedDates.slice();
    let startDate, endDate;
    let dateRange = [], rangeStart, rangeEnd;

    if (disabled) {
      return;
    }

    let range = addToRange(day, this.state, 1);
    if (!range && this.state.from && !this.state.to && moment(day).isSame(this.state.from, 'day')) {
      range = { from: day, to: day };
    }
    startDate = range?.from;
    endDate = range?.to;

    if (range?.from) {
      startDate = new Date(range.from);
      startDate.setHours(12, 0, 0, 0);
    }
    if (range?.to) {
      endDate = new Date(range.to);
      endDate.setHours(12, 0, 0, 0);
    }

    if (!range) {
      startDate = null;
      endDate = null;
      dateRange = [], selectedDays = [];
    } else if (startDate && !endDate) {
      rangeStart = new Date(startDate);
      dateRange.push(rangeStart);
    } else if (startDate && endDate) {
      rangeStart = new Date(startDate);
      rangeEnd = new Date(endDate);
      if (!moment(rangeStart).isSame(rangeEnd)) {
        dateRange.push(rangeStart);

        rangeStart = new Date(+rangeStart);

        while (rangeStart < endDate) {

          dateRange.push(rangeStart);
          var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      } else {
        dateRange.push(rangeStart);
      }
    }
    this.setState({ selectedDays, dateRange, from: startDate, to: endDate });

    change('ListPlaceStep3', 'startDate', startDate)
    change('ListPlaceStep3', 'endDate', endDate)
  }

  resetCalendar() {
    const { change } = this.props;
    this.setState({ dateRange: [], from: null, to: null, startDate: null, endDate: null });
    change('ListPlaceStep3', 'startDate', null)
    change('ListPlaceStep3', 'endDate', null)
  }

  resetDatePickerChange() {
    const { change } = this.props;
    this.setState({ dateRange: [], from: null, to: null });
  }

  setNextMonth = () => {
    this.setState({ month: moment(this.state.month).add(1, 'month') });
  }

  setPrevMonth = () => {
    const monthData = moment(this.state.month).subtract(1, 'month');
    if (moment(monthData).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
      this.setState({ month: monthData });
    }
  }

  handleTodayClick = () => {
    this.setState({ month: moment() })
  }

  render() {
    const { selectedDays, from, to, dateRange, month } = this.state;
    const { disabledDates, formName, listId, availableDates, locale } = this.props;
    const { minDay, maxDay, houseRules, checkInEnd, checkInStart } = this.props;
    const { cancellationPolicy, maxDaysNotice, bookingNoticeTime } = this.props;
    const { delivery, basePrice, currency, weeklyDiscount, monthlyDiscount, securityDeposit } = this.props;
    const { isStartDate, isEndDate, todayLabel, setStateLoading, isSaving, isBlocking } = this.props;
    const { formatMessage } = this.props.intl;
    const selectedRange = from ? { from, to: to || undefined } : undefined;

    const modifiers = {
      start: from,
      end: to,
      selecting: dateRange,
      blocked: selectedDays,
      available: availableDates,
      booked: disabledDates,
      disabled: [
        { before: new Date() }, ...disabledDates
      ],
    };

    const modifiersClassNames = {
      blocked: 'fullyBlocked',
      selecting: 'customDayCalendarSelecting',
      available: 'fullyAvailable',
      booked: 'fullyBooked',
      start: 'selectingStart',
      end: 'selectingEnd',
      disabled: 'disabledDates'
    }


    const customBecomeHostDayPickerClass = {
      nav: "becomeHostMonthNav",
      month_caption: "becomeHostMonthCaption",
      caption_label: "becomeHostMonthCaptionLabel",
      months: "becomeHostMonthsGroup",
      month_grid: 'becomeHostMonthTable',
      weekdays: 'becomeHostWeekdaysGroup',
      weekday: 'weekdaySection',
      month: 'becomeHostSingleMonth',
      weeks: "becomeHostWeeksGrpBody",
      week: "becomeHostSingleWeek",
      day: "becomeHostSingleDay",
      day_button: "becomeHostInnerDayBtn",
      button_previous: "becomeHostMonthNavPrevBtn",
      button_next: "becomeHostMonthNavNextBtn",
      chevron: 'displayNone',
      selected: null,
      range_start: null,
      range_middle: null,
      range_end: null
    }

    return (
      <Row>
        <Col lg={8} md={12} sm={12} xs={12}>
          <div className={cx('becomeHostCalendarBox', !(from || isStartDate) && "becomeHostCalendarSpacing")}>
            <Button onClick={() => this.handleTodayClick()} className='becomeHostCalendarTodayBtn'>
              {formatMessage(messages.toDay)}
            </Button>
            <DayPicker
              month={month}
              mode="range"
              selected={selectedRange}
              onDayClick={this.handleDayClick}
              modifiers={modifiers}
              disabled={{ before: new Date() }}
              disabledDays={[...disabledDates]}
              locale={localeArray[locale]}
              dir={isRTL(locale) ? 'rtl' : 'ltr'}
              onNextClick={this.setNextMonth}
              onPrevClick={this.setPrevMonth}
              components={{ Day: this.renderDay }}
              startMonth={moment()}
              className={'becomeHostCalendarContainer'}
              classNames={customBecomeHostDayPickerClass}
              modifiersClassNames={modifiersClassNames}
              transitionDuration={0}
            />
          </div>
        </Col>
        <Col lg={4} md={4} sm={6} xs={12}>
          <SaveCalendar
            selectedDays={dateRange}
            start={from}
            end={to}
            formName={formName}
            resetCalendar={this.resetCalendar}
            resetDatePickerChange={this.resetDatePickerChange}
            listId={listId}
            minDay={minDay}
            maxDay={maxDay}
            houseRules={houseRules}
            checkInEnd={checkInEnd}
            checkInStart={checkInStart}
            cancellationPolicy={cancellationPolicy}
            maxDaysNotice={maxDaysNotice}
            bookingNoticeTime={bookingNoticeTime}
            delivery={delivery}
            basePrice={basePrice}
            currency={currency}
            isStartDate={isStartDate}
            isEndDate={isEndDate}
            weeklyDiscount={weeklyDiscount}
            monthlyDiscount={monthlyDiscount}
            setStateLoading={setStateLoading}
            isSaving={isSaving}
            isBlocking={isBlocking}
            securityDeposit={securityDeposit}
          />

        </Col>
      </Row>
    );
  }

}


const selector = formValueSelector('ListPlaceStep3');
const mapState = (state) => ({
  isStartDate: selector(state, 'startDate'),
  isEndDate: selector(state, 'endDate'),
  locale: state.intl.locale,
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, t)(connect(mapState, mapDispatch)(DayDragCalendar)));
